
import { getStorage } from 'helpers/sessionContext';
export const isDebugEnabled = () => {
  if (typeof window === 'undefined') return false;
  return getStorage().getItem('CINCEL_DEBUG') === 'true';
};

export const logger = {
  log: (message: string, ...args: any[]) => {
    if (isDebugEnabled()) {
      const now = new Date().toISOString().split('T')[1].replace('Z', '');
      console.log(`%c[${now}] [CINCEL] ${message}`, 'color: #3b82f6; font-weight: bold', ...args);
    }
  },
  analytics: (event: string, properties: any) => {
    if (getStorage().getItem('CINCEL_DEBUG_ANALYTICS') === 'true') {
      const now = new Date().toISOString().split('T')[1].replace('Z', '');
      console.log(`%c[${now}] [TRACKING] 📊 ${event}`, 'color: #10b981; font-weight: bold', properties);
    }
  },
  warn: (message: string, ...args: any[]) => {
    if (isDebugEnabled()) {
      const now = new Date().toISOString().split('T')[1].replace('Z', '');
      console.warn(`[${now}] [CINCEL] ${message}`, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    const now = new Date().toISOString().split('T')[1].replace('Z', '');
    console.error(`[${now}] [CINCEL] ${message}`, ...args);
  }
};
